import React from 'react';
import CreatePostContainer from '../templates/create-post/CreatePostContainer';
const CreatePostPage = () => (
  <CreatePostContainer />
);

export default CreatePostPage;
// import React from "react";
// import { withRouter } from "react-router";
// import { gql, graphql, compose } from "react-apollo";
// import _ from 'lodash'
// import axios from 'axios'

// class CreatePost extends React.Component {
//   state = {
//     description: "",
//     imageId: "",
//     isPrivate: false,
//     sendTo: undefined,
//     sendToUrl: "https://www.facebook.com/poladet.a"
//   };

//   onChange = ({ target }) => {
//     const { name } = target
//     const value = target.type === "checkbox" ? target.checked : target.value;
//     this.setState({ [name]: value });
//   };

//   onCheckSentTo = async (url) => {
//     const result = await axios.get(this.state.sendToUrl, { crossdomain: true })
//     const html = /content="fb:\/\/profile\/(\w+)/g.exec(_.get(result, 'data'))
//     const fbId = _.get(html, 1)
//     console.log('fbId', html, fbId)
//     if(fbId){
//       this.setState({sendTo: fbId})
//     }else{
//       alert('not found')
//     }

//   }

//   render() {
//     if (this.props.data.loading) {
//       return <div>Loading</div>;
//     }

//     return (
//       <div className="w-100 pa4 flex justify-center">
//         <div style={{ maxWidth: 400 }} className="">
//           <input
//             className="w-100 pa3 mv2"
//             name="description"
//             value={this.state.description}
//             placeholder="Description"
//             onChange={this.onChange}
//           />
//           <input
//             className="w-100 pa3 mv2"
//             name="imageId"
//             value={this.state.imageId}
//             placeholder="Image Url"
//             onChange={this.onChange}
//           />
//           <input type="checkbox" name="isPrivate" onChange={this.onChange} />
//           <span> isPrivate</span>
//           <input type="text" name="sendToUrl" onChange={this.onSendToChange} value={this.state.sendToUrl}/>
//           {this.state.sendTo}
//           <button onClick={this.onCheckSentTo}>Check</button>
          
//           {this.state.imageId && (
//             <img
//               src={this.state.imageId}
//               role="presentation"
//               className="w-100 mv3"
//             />
//           )}
//           {this.state.description &&
//             this.state.imageId && (
//               <button
//                 className="pa3 bg-black-10 bn dim ttu pointer"
//                 onClick={this.handlePost}
//               >
//                 Post
//               </button>
//             )}
//         </div>
//       </div>
//     );
//   }

//   handlePost = async () => {
//     try{
//       const loggedInUser = this.props.data.loggedInUser;
//       // redirect if no user is logged in
//       if (!loggedInUser) {
//         console.warn("Only logged in users can create new posts");
//         this.props.history.push("/");
//         return;
//       }
  
//       const { description, imageId, isPrivate, sendTo } = this.state;
//       const authorId = loggedInUser.id;
  
//       await this.props.CreatePostMutation({
//         variables: { description, imageId, authorId, isPrivate, sendTo  }
//       });
//       this.props.history.push("/");

//     }catch(error){
//       console.log(error.name)
//       console.log(error.message)
//       console.log(error.stack)
//     }
//   };
// }

// const LOGGED_IN_USER = gql`
//   query LoggedInUser {
//     loggedInUser {
//       id
//     }
//   }
// `;

// const CREATE_POST = gql`
//   mutation CreatePost(
//     $description: String!
//     $imageId: String!
//     $isPrivate: Boolean!
//     $authorId: ID!
//     $sendTo: String!
//   ) {
//     createPost(
//       description: $description
//       imageId: $imageId
//       isPrivate: $isPrivate
//       authorId: $authorId
//       sendTo: $sendTo
//     ) {
//       id
//     }
//   }
// `;

// export default compose(
//   graphql(LOGGED_IN_USER, { options: { fetchPolicy: "network-only" } }),
//   graphql(CREATE_POST, { name: "CreatePostMutation" })
// )(withRouter(CreatePost));



// WEBPACK FOOTER //
// ./src/pages/CreatePostPage.js